module.exports = __webpack_public_path__ + "img/banner01.494d17a9.jpg";